import { selectUserPromotionStatus } from '../../../selectors/user/userPrimary.selector';
import type { StateType } from '../../../states';
import { PromotionStatuses } from '../../../types/promotions';
import type { Selector } from '../../../types/selectors';
import { GRVersion } from '../constants/meta';
import { GRGlobalStatuses, GRSkinIds } from '../types/global';
import { GROperationUserStatuses } from '../types/user';

import { selectGRGlobalSkinId, selectGRGlobalStatus, selectGRGlobalVersion } from './global/globalPrimary.selector';
import { selectGRUserStatus, selectIsGRUserForbidden } from './user/userPrimary.selector';

export const selectIsGREnabled: Selector<boolean> = (state: StateType) => {
  const userStatus = selectGRUserStatus(state);
  const version = selectGRGlobalVersion(state);
  const globalStatus = selectGRGlobalStatus(state);
  const skinId = selectGRGlobalSkinId(state) || '';
  const promotionStatus = selectUserPromotionStatus(state);

  return (
    (globalStatus === GRGlobalStatuses.RUNNING || globalStatus === GRGlobalStatuses.ENDING) &&
    version === GRVersion &&
    userStatus !== GROperationUserStatuses.EXCLUDED &&
    promotionStatus === PromotionStatuses.DEFAULT &&
    Object.keys(GRSkinIds).includes(skinId)
  );
};

export const selectIsGREnabledAndNotForbidden: Selector<boolean> = (state: StateType) => {
  const isGREnabled = selectIsGREnabled(state);
  const isForbiden = selectIsGRUserForbidden(state);

  return isGREnabled && !isForbiden;
};

export const selectIsGRPlayable: Selector<boolean> = (state: StateType) => {
  const isGREnabled = selectIsGREnabledAndNotForbidden(state);
  const status = selectGRGlobalStatus(state);

  return status === GRGlobalStatuses.RUNNING && isGREnabled;
};
